import { render } from "./EventIcons.vue?vue&type=template&id=be01ac3c"
import script from "./EventIcons.vue?vue&type=script&lang=js"
export * from "./EventIcons.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vixfs/PhpstormProjects/fitbase/frontend/web/vue-resources/personal-account/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__